function milesNumeros(numero) {
    // return numero.toString().replace(/(\.\d+)|\B(?=(\d{3})+(?!\d))/g, function (m, g1) {
    //     return g1 || ","
    // });

    return Number(numero).toLocaleString('en-US');
};


export const formatMoney = (value) => {

    let formateado = Number(value).toFixed(2)
    formateado = milesNumeros(formateado);
    return formateado
}

